/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceHtmlResponse
 */
export interface InvoiceHtmlResponse {
    /**
     * 
     * @type {string}
     * @memberof InvoiceHtmlResponse
     */
    invoiceHtml: string;
}

export function InvoiceHtmlResponseFromJSON(json: any): InvoiceHtmlResponse {
    return {
        'invoiceHtml': json['invoiceHtml'],
    };
}

export function InvoiceHtmlResponseToJSON(value?: InvoiceHtmlResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'invoiceHtml': value.invoiceHtml,
    };
}


